import React from 'react';
import { baseColors } from '@groupby/ui-components';
export const renderBoldText = (chunks) => <b>{chunks}</b>;
const grayStyles = { color: baseColors.primaryBlueMed600, fontWeight: 700 };
export const renderGrayText = (chunks) => <span style={grayStyles}>{chunks}</span>;
export const renderAccentText = (chunks) => <b><i>{chunks}</i></b>;
export const renderHighLightText = (chunks) => <span style={{ color: baseColors.blue300 }}>{chunks}</span>;
export const renderSubduedText = (chunks) => <i style={{ color: baseColors.primaryBlueMed600 }}>{chunks}</i>;
